import React from "react";
import Layout from "../Layout/Layout";

export default function Dashboard() {
    return (
        <Layout>
            
        </Layout>
    );
}